import { __objRest, __spreadProps, __spreadValues } from "./chunk-ORMEWXMH.js";

// src/elements/ScrollIntoView/ScrollIntoView.tsx
import { useEffect, useRef } from "react";
import { jsx } from "react/jsx-runtime";
var DEFAULT_COMPONENT = "div";
var ScrollIntoView = _a => {
  var _b = _a,
    {
      as,
      children,
      scrollIntoView = true,
      scrollBehavior = "smooth",
      scrollBlock = "nearest",
      scrollInline = "nearest",
      onUnmount
    } = _b,
    rest = __objRest(_b, ["as", "children", "scrollIntoView", "scrollBehavior", "scrollBlock", "scrollInline", "onUnmount"]);
  const Component = as || DEFAULT_COMPONENT;
  const ref = useRef(null);
  useEffect(() => {
    var _a2;
    if (scrollIntoView && typeof ((_a2 = ref.current) == null ? void 0 : _a2.scrollIntoView) === "function") {
      ref.current.scrollIntoView({
        behavior: scrollBehavior,
        block: scrollBlock,
        inline: scrollInline
      });
    }
  }, [scrollBehavior, scrollBlock, scrollInline, scrollIntoView]);
  useEffect(() => () => {
    onUnmount == null ? void 0 : onUnmount();
  }, [onUnmount]);
  return /* @__PURE__ */jsx(Component, __spreadProps(__spreadValues({
    ref
  }, rest), {
    children
  }));
};
var ScrollIntoView_default = ScrollIntoView;
export { ScrollIntoView_default };